import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=3583eba4"
import script from "./Demand.vue?vue&type=script&lang=js"
export * from "./Demand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports